<template>
  <section>
    <section class="grid-flex column" style="margin-bottom: 8px;">
      <!-- filters -->
      <div class="flex-1 w100">
        <div class="flex">
          <tabs :data="reportTabs" v-model="currentTab" type="default-scroll"></tabs>
        </div>
      </div>
    </section>
    <!-- profit -->
    <profit v-if="currentDashType === 'PROFIT'" :dash="currentDash" :key="refreshDashKey"></profit>
    <!-- sale -->
    <sale v-if="currentDashType === 'SALE'" :dash="currentDash" :key="refreshDashKey"></sale>
    <!-- funnel -->
    <funnel v-if="currentDashType === 'FUNNEL'" :dash="currentDash" :key="refreshDashKey"></funnel>
    <!-- lead -->
    <lead v-if="currentDashType === 'LEAD'" :dash="currentDash" :key="refreshDashKey"></lead>
    <!-- message -->
    <message v-if="currentDashType === 'MESSAGE'" :dash="currentDash" :key="refreshDashKey"></message>
    <!-- new dash -->
    <new-dash v-if="currentDashType === 'new-dash'" @new="updateDash($event)" :key="refreshDashKey"></new-dash>

    <div v-if="loading">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
    </div>

    <div v-if="!loading && currentTab == 'first'" class="flex box w100">
      <div class="box-content">
        <div>
          Crie seu primeiro Dashboard e comece a companhar todas suas métricas.
        </div>
        <div class="margin-top-l">
            <router-link :to="{ name: 'Dash', params: {slug: 'new-dash'} }">
              <div class="button secondary">
                Lucratividade
              </div>
            </router-link>
            <router-link :to="{ name: 'Dash', params: {slug: 'new-dash'} }">
              <div class="button secondary">
                Captação de Leads
              </div>
            </router-link>
            <router-link :to="{ name: 'Dash', params: {slug: 'new-dash'} }">
              <div class="button secondary">
                Conversas no WhatsApp
              </div>
            </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import { getDashboards } from "@/services/dashboard";

import Tabs from "@/components/tabs/Tabs";

import Profit from "./Profit";
import Sale from "./Sale";
import Lead from "./Lead";
import Message from "./Message";
import Funnel from "@/modules/funnel/Funnel";
import NewDash from "./NewDash";

export default {
  name: "dash-detail",
  components: {
    Tabs,
    Profit,
    Sale,
    Lead,
    Funnel,
    Message,
    NewDash
  },
  props: ['slug'],
  data() {
    return {
      loading: false,
      currentTab: "profit",
      refreshDashKey: 0,
      dash: []
    };
  },
  mounted() {
    if (this.slug) {
      this.currentTab = this.slug
    }

    this.getDashboards()
  },
  watch: {
    slug() {
      if (this.slug) {
        this.currentTab = this.slug
      }

      var find = this.dash.find(e=> e.id == this.currentTab)
      if (!find) {
          this.getDashboards()
      }
    },
    currentTab() {
      if (this.slug === this.currentTab) {
        return
      }
      this.$router.push({ name: "Dash", params: { slug: this.currentTab } });
    },
    currentDash() {
      // fix to refresh elements in change tabs
      this.refreshDashKey += 1
    }
  },
  computed: {
    currentDash() {
      if (this.currentTab == "new-dash") {
        return {}
      }

      var find = this.dash.find(e=> e.id == this.currentTab)
      if (!find) {
        return {}
      }

      return find
    },
    currentDashType() {
      if (this.currentTab == "new-dash") {
        return "new-dash"
      }

      var find = this.dash.find(e=> e.id == this.currentTab)
      if (!find) {
        return ""
      }

      return find.dash_type
    },
    reportTabs() {
      var tabs = []
      tabs = this.dash.map(e => { return { 
        name: e.id,
        title: e.name,
        dash_type: e.dash_type,
        id: e.id
      } })

      tabs.push({
        name: "new-dash",
        title: "+ Criar Dashboard",
      },)

      return tabs
    },

  },
  methods: {
    updateDash(newDash) {
      this.dash.splice(this.dash.length - 1, 0, newDash);
    },
    getDashboards() {
      this.loading = true
      getDashboards()
        .then(result => {
          this.dash = result.dashs

          if (this.slug === 'first') {
            var _slug = 'new-dash'
            if (this.dash.length > 0) {
              _slug = this.dash[0].id
              this.currentTab = _slug
            }
          }
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }

};
</script>

<style lang="scss" scoped></style>
